import React from "react";
import { connect } from "react-redux";
import Drawer from 'devextreme-react/drawer';
import Toolbar, { Item } from "devextreme-react/toolbar";
import List from "devextreme-react/list";
import notify from 'devextreme/ui/notify';
import Form from "devextreme-react/form";
import ArrayStore from "devextreme/data/array_store";
import { ABECASUSER_LOGIN_TYPE } from "../../../common/permissions";
import { alert } from 'devextreme/ui/dialog';
import Popup from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import CommitTransactionsGridPreview from "../genaric-component/TransactionsGridPreview";
import CommitTransactionsPrintErrors from "../genaric-component/TransactionsPrintErrors";
import { Button } from 'devextreme-react/button';

import DataGrid, {
    Column,
    Editing,
    Lookup,
} from "devextreme-react/data-grid";
import Accordion from 'devextreme-react/accordion';
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { LoadPanel } from 'devextreme-react/load-panel';
import { DateBox, NumberBox, SelectBox, TextBox } from "devextreme-react";

const searchpanel = [
    {
        ID: 1,
        Name: 'Search Filters'
    }
];
const list = React.createRef();
const dataGrid = React.createRef();
let ignoreListSelectionChange = false;
let ignoreMacroSelectionChange = false;
const selectBox = React.createRef();
const selectBoxMacro = React.createRef();
const orderByData = [
    { ID: 0, Text: "None" },
    { ID: 1, Text: "Ascending" },
    { ID: 2, Text: "Descending" },
];

const orderByDataSource = new ArrayStore({
    data: orderByData,
    key: "ID",
});

const prefixData = [
    { ID: 0, Text: "And" },
    { ID: 1, Text: "Or" },
];

const prefixDataSource = new ArrayStore({
    data: prefixData,
    key: "ID",
});
const groupData = [
    { ID: 0, Text: "No" },
    { ID: 1, Text: "Begin" },
    { ID: 2, Text: "End" },
];
const operationData = [
    { ID: 0, Text: "StartsWith" },
    { ID: 1, Text: "EndsWith" },
    { ID: 2, Text: "Contains" },
    { ID: 3, Text: "Equal" },
    { ID: 4, Text: "NotEqual" },
    { ID: 5, Text: "Greater" },
    { ID: 6, Text: "GreaterEqual" },
    { ID: 7, Text: "Less" },
    { ID: 8, Text: "LessEqual" },
    { ID: 9, Text: "Between" },
    { ID: 10, Text: "Includes" },
];

const groupDataSource = new ArrayStore({
    data: groupData,
    key: "ID",
});
const operationDataSource = new ArrayStore({
    data: operationData,
    key: "ID",
});

let accessToken = "";
class ReplicateOMTransaction extends React.Component {
    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;
        this.ReplicateButtonClicked = this.ReplicateButtonClicked.bind(this);
        this.previewButtonClicked = this.previewButtonClicked.bind(this);
        this.resetButtonClicked = this.resetButtonClicked.bind(this);
        this.selectionChanged = this.selectionChanged.bind(this);
        this.loadOMTransactionFields = this.loadOMTransactionFields.bind(this);
        this.dataFieldSelectionChanged = this.dataFieldSelectionChanged.bind(this);
        this.dataFieldRender = this.dataFieldRender.bind(this);
        this.ProfileMethodChanged = this.ProfileMethodChanged.bind(this);
        this.LoadProfiles = this.LoadProfiles.bind(this);
        this.ReplicateSettingsValuesChanged = this.ReplicateSettingsValuesChanged.bind(this);
        this.handleClosePreviewPopUpCallback = this.handleClosePreviewPopUpCallback.bind(this);
        this.handleClosePrintErrorsPopUpCallback = this.handleClosePrintErrorsPopUpCallback.bind(this);

        this.state = this.getInitialState(props);

        this.toolbarItems = [{
            widget: 'dxButton',
            location: 'right',
            options: {
                icon: 'menu',
                onClick: () => this.setState({ opened: !this.state.opened }),
            },
        }];
        this.loadOMTransactionFields();

        this.arrStage = [
            { id: 1, name: 'Assigned - Effect Available', value: 'A' },
            { id: 2, name: 'Shipped/Completed - Effect Available', value: 'C' },
            { id: 3, name: 'Future - No Effect On Net Available', value: 'F' },
            { id: 4, name: 'Canceled - No Inventory Effect', value: 'L' },
            { id: 5, name: 'Pending - Effects Net Available', value: 'N' },
            { id: 6, name: 'Plan - No Inventory Effect', value: 'P' },
            { id: 7, name: 'Quote - No Inventory Effect', value: 'Q' },
            { id: 8, name: 'Picked/Staged - Effect Available', value: 'S' }
        ];
        this.arrStatus = [
            { id: 1, name: 'Hold', value: 'H' },
            { id: 2, name: 'Ready To Commit Later', value: 'L' },
            { id: 3, name: 'Open', value: 'O' },
            { id: 4, name: 'Commited', value: 'Z' },
        ];
        this.arrUpdatePrices = [
            { id: 1, name: 'No', value: 'N' },
            { id: 2, name: 'Yes', value: 'Y' }
        ];
        this.arrClearDiscounts = [
            { id: 1, name: 'No, Keep original Total and Detail Discounts', value: 'A' },
            { id: 2, name: 'Yes, Clear Detail discounts', value: 'B' },
            { id: 3, name: 'Yes, Clear Total discounts', value: 'C' },
            { id: 4, name: 'Yes, Clear both Total and Detail discounts', value: 'D' }
        ];
        this.arrDateMethod = [
            { id: 1, name: 'Fixed - Use Order Date Specified', value: '0' },
            { id: 2, name: 'Sliding - Add Days To Original Transaction Date', value: '1' }
        ];
        this.arrProfileMethod = [
            { id: '0', text: 'Use Original Profile' },
            { id: '1', text: 'Use Different Profile' }
        ];
    }
    getInitialState(props) {
        return {
            animationDuration: 300,
            selectedItems: [],
            loadComitIndicatorVisible: false,
            isPreviewGridPopupVisible: false,
            isPrintPreviewPopupVisible: false,
            connection: null,
            ABErros: [],
            previewData: [],
            opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
            generatedFileName: "",
            report: {
                key: "",
                name: "",
                fullName: "",
                ignoreCompany: false,
                parameterList: [],
                queryParameters: [],
                whereInfoList: [],
                filterWhereInfoList: [
                ],
            },
            settings: {
                profilemethod: "0",
                profileid: "",
                stage: "A",
                status: "O",
                newwarehouse: "",
                ponumber: "",
                updateprices: "",
                cleardiscounts: "A",
                orderdatemethod: "0",
                ordernoofdays: 0,
                isOrderNoOfDaysEnabled: false,
                orderdate: new Date(),
                shipdatemethod: "0",
                shipnoofdays: 0,
                isShipNoOfDaysEnabled: false,
                shipdate: new Date(),
                isProfileNeeded: false,
                profileArr: [],
                newWHArr: []
            },
            formData: {},
            formItems: [],
        };
    }
    handleClosePreviewPopUpCallback() {
        this.setState({
            isPreviewGridPopupVisible: false,
        });
    };
    handleClosePrintErrorsPopUpCallback() {
        this.setState({
            isPrintPreviewPopupVisible: false,
        });
    };
    printErrorsButtonClicked = async () => {
        this.setState({
            isPrintPreviewPopupVisible: true,
        });
        this.setState({
            loadIndicatorVisible: true
        });
        const data = await this.GetABErrorswData();
        this.setState({
            ABErros: data,
            isPrintPreviewPopupVisible: true,
            loadIndicatorVisible: false
        });
    }
    GetABErrorswData = async () => {
        try {
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.GetABErrorsHeadersForReplicate}`,
                JSON.stringify("OMWEBREPLI"),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return res.data; // Return the response data
        } catch (error) {
            this.setState({
                loadIndicatorVisible: false
            });
            console.error('Error when fetching Replicate Transaction ABErrorsHeaders data:', error);
            throw error; // Re-throw the error for handling in the component
        }
    };
    ReplicateButtonClicked = async () => {
        this.setState({
            loadIndicatorVisible: true,
        });
        const response = await this.ReplicateOMTransactions();
        if(response.success){
            alert(response.message, "Success");
        }
        else{
            notify({
                message: response.message,
                width: 500,
            }, (response.success ? 'success' : 'error'), 5000);
        }
        this.setState({
            loadIndicatorVisible: false,
        });
    }
    ReplicateOMTransactions = async () => {
        try {
            let filterWhereInfoList = {
                filterWhereInfoList: this.state.report.filterWhereInfoList,
                ...this.state.settings
            };
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.StartReplicateTransaction}`,
                JSON.stringify(filterWhereInfoList),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            this.setState({
                loadIndicatorVisible: false,
            });
            notify({
                message: 'Replicate Process Failed Due To Data Errors - Use Print Errors Button View Report',
                width: 450,
            }, 'error', 2000);
            console.error('Error Replicate OM transaction.', error);
        }
    };
    async previewButtonClicked() {
        this.setState({
            loadIndicatorVisible: true
        });
        const data = await this.PreviewData();
        this.setState({
            previewData: data,
            isPreviewGridPopupVisible: true,
            loadIndicatorVisible: false
        });
    }
    PreviewData = async () => {
        try {
            let filterWhereInfoList = { filterWhereInfoList: this.state.report.filterWhereInfoList };
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${routes.OM.GetReplicateOMTransaction}`,
                JSON.stringify(filterWhereInfoList),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            this.setState({
                loadIndicatorVisible: false
            });
            console.error('Error Getting Transaction Data:', error);
            throw error;
        }
    }
    ReplicateSettingsValuesChanged(ctrlName, value) {
        this.setState(prvState => ({
            settings: {
                ...prvState.settings,
                [ctrlName]: value,
                isShipNoOfDaysEnabled: ctrlName == "shipdatemethod" ? value == "1" : prvState.settings.isShipNoOfDaysEnabled,
                isOrderNoOfDaysEnabled: ctrlName == "orderdatemethod" ? value == "1" : prvState.settings.isOrderNoOfDaysEnabled
            }
        }));
    }
    ProfileMethodChanged(e) {
        if (e.value == 1) {
            this.setState(prvState => ({
                settings: {
                    ...prvState.settings,
                    profilemethod: e?.value,
                    isProfileNeeded: true
                }
            }));
            this.LoadProfiles();
        }
        else {
            this.setState(prvState => ({
                settings: {
                    ...prvState.settings,
                    profileArr: [],
                    profileid: '',
                    profilemethod: e?.value,
                    isProfileNeeded: false
                }
            }));
        }
    }
    LoadProfiles() {
        this.setState({
            loadIndicatorVisible: true,
        });
        axios.get(
            `${window._env_.REACT_APP_APIS}/${routes.OM.GetProfiles}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((res) => {
            if (res.status == 200) {
                const newOptions = res.data.lookups.map(item => ({
                    id: item.rowid,
                    name: item.code
                }));
                this.setState(prvState => ({
                    settings: {
                        ...prvState.settings,
                        profileArr: newOptions
                    }
                }));
                this.setState({
                    loadIndicatorVisible: false,
                });
            }
        }).catch((err) => {
            notify({
                message: 'Couldnt Load Profiles Data!!',
                width: 450,
            }, 'error', 2000);
            this.setState({
                loadIndicatorVisible: false,
            });
        });
    }
    resetButtonClicked() {
        this.setState(this.getInitialState(this.props), () => {
            this.loadOMTransactionFields();
        });
    }
    selectionChanged(e) {
        let newItems = [...this.state.selectedItems];
        e.removedItems.forEach((item) => {
            const index = newItems.indexOf(item);
            if (index >= 0) {
                newItems.splice(index, 1);
            }
        });
        if (e.addedItems.length) {
            newItems = [...newItems, ...e.addedItems];
        }
        this.setState({
            selectedItems: newItems
        });
    }
    dataFieldRender(e) {
        var dataSource = dataGrid.current.instance().getDataSource();
        if (dataSource != null && dataSource._items != null) {
            var found = dataSource._items.find(i => i.origin == e.itemData.origin);
            if (found != null && found != undefined) {
                if (!e.component.isItemSelected(e.itemIndex)) {
                    ignoreListSelectionChange = true;
                    e.component.selectItem(e.itemIndex);
                    ignoreListSelectionChange = false;
                }
            }
        }
    }
    dataFieldSelectionChanged(e) {
        if (!ignoreListSelectionChange) {
            if (e.addedItems != null && e.addedItems.length === 1) {
                var dataSource = dataGrid.current.instance().getDataSource();
                dataSource
                    .store()
                    .insert(e.addedItems[0])
                    .done(function (dataObj, key) {
                        dataSource.reload();
                    })
                    .fail(function (error) {
                        alert(error);
                    });
            }

            if (e.removedItems != null && e.removedItems.length === 1) {
                var dataSource = dataGrid.current.instance().getDataSource();
                dataSource
                    .store()
                    .remove(e.removedItems[0].displayLabel)
                    .done(function (dataObj, key) {
                        dataSource.reload();
                    })
                    .fail(function (error) {
                        alert(error);
                    });
            }
        }
    }
    loadOMTransactionFields() {
        axios
            .get(`${window._env_.REACT_APP_APIS}/${routes.OM.GetWarehousesReplicate}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            ).then((res) => {
                if (res.data.success) {
                    this.setState(prvState => ({
                        settings: {
                            ...prvState.settings,
                            newWHArr: res.data.resultdata
                        }
                    }));
                }
            });
        var that = this;
        axios
            .get(
                `${window._env_.REACT_APP_APIS}/${routes.reports.GetReport}?reportName=${'REPLICATEOMTRANSACTION'}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
            .then((res) => {

                for (
                    var i = 0;
                    res.data.filterWhereInfoList != null &&
                    i < res.data.filterWhereInfoList.length;
                    i++
                ) {
                    switch (res.data.filterWhereInfoList[i].fieldType) {
                        case 5: // Flag
                            for (
                                var j = 0;
                                res.data.filterWhereInfoList[i].items != null && j < res.data.filterWhereInfoList[i].items.length;
                                j++
                            ) {

                                if (res.data.filterWhereInfoList[i].from == res.data.filterWhereInfoList[i].items[j].value) {
                                    res.data.filterWhereInfoList[i].from = res.data.filterWhereInfoList[i].items[j].text;
                                }

                                if (res.data.filterWhereInfoList[i].to == res.data.filterWhereInfoList[i].items[j].value) {
                                    res.data.filterWhereInfoList[i].to = res.data.filterWhereInfoList[i].items[j].text;
                                }
                            }
                            break;
                        default:
                    }
                }

                for (
                    var i = 0;
                    res.data.whereInfoList != null &&
                    i < res.data.whereInfoList.length;
                    i++
                ) {
                    switch (res.data.whereInfoList[i].fieldType) {
                        case 5: // Flag
                            for (
                                var j = 0;
                                res.data.whereInfoList[i].items != null && j < res.data.whereInfoList[i].items.length;
                                j++
                            ) {

                                if (res.data.whereInfoList[i].from == res.data.whereInfoList[i].items[j].value) {
                                    res.data.whereInfoList[i].from = res.data.whereInfoList[i].items[j].text;
                                }

                                if (res.data.whereInfoList[i].to == res.data.whereInfoList[i].items[j].value) {
                                    res.data.whereInfoList[i].to = res.data.whereInfoList[i].items[j].text;
                                }
                            }
                            break;
                        default:
                    }
                }

                that.setState({
                    report: res.data,
                });

                var formData = new Object();

                var formItems = [];

                for (
                    var i = 0;
                    that.state.report.parameterList != null &&
                    i < that.state.report.parameterList.length;
                    i++
                ) {
                    formData[that.state.report.parameterList[i].name] =
                        that.state.report.parameterList[i].value;
                    var formItem = new Object();
                    formItem.dataField = that.state.report.parameterList[i].name;
                    formItem.label = new Object();
                    formItem.label.text = that.state.report.parameterList[i].label;
                    switch (that.state.report.parameterList[i].parameterType) {
                        case 1: // Integer
                        case 2: // Decimal
                            formItem.editorType = "dxNumberBox";
                            break;
                        case 3: // Boolean
                            formItem.editorType = "dxCheckBox";
                            break;
                        case 4: // DateTime
                            formItem.editorType = "dxDateBox";
                            break;
                        case 5: // Flag
                            formItem.editorType = "dxSelectBox";
                            formItem.editorOptions = new Object();
                            formItem.editorOptions.items = [];

                            for (
                                var j = 0;
                                j < that.state.report.parameterList[i].items.length;
                                j++
                            ) {
                                var selectBoxItem = new Object();
                                selectBoxItem.Value =
                                    that.state.report.parameterList[i].items[j].value;
                                selectBoxItem.Text =
                                    that.state.report.parameterList[i].items[j].text;
                                formItem.editorOptions.items.push(selectBoxItem);
                            }

                            formItem.editorOptions.displayExpr = "Text";
                            formItem.editorOptions.valueExpr = "Value";
                            break;
                        default:
                            formItem.editorType = "dxTextBox";
                    }

                    formItems.push(formItem);
                }

                that.setState({
                    formData: formData,
                });

                that.setState({
                    formItems: formItems,
                });

                var dataFilterDataSource = new ArrayStore({
                    data: that.state.report.filterWhereInfoList,
                    key: "displayLabel",
                });

                dataGrid.current.instance().option("dataSource", dataFilterDataSource);


                ignoreListSelectionChange = true;
                for (var i = 0; res.data.whereInfoList != null && i < res.data.whereInfoList.length; i++) {
                    for (var j = 0; res.data.filterWhereInfoList != null && j < res.data.filterWhereInfoList.length; j++) {
                        if (res.data.whereInfoList[i].origin == res.data.filterWhereInfoList[j].origin) {
                            if (!list.current.instance().isItemSelected(i)) {
                                list.current.instance().selectItem(i);
                            }
                            break;
                        }
                    }
                }
                ignoreListSelectionChange = false;
            })
            .catch((err) => {
                console.log(err, "Error getting data");
            });
    }
    render() {
        return (
            <>
                <div>
                    <div className="row ">
                        <div className="col-md-12 main-page">
                            <div id="accordion" >
                                <Accordion
                                    dataSource={searchpanel}
                                    collapsible={true}
                                    multiple={false}
                                    animationDuration={this.state.animationDuration}
                                    selectedItems={this.state.selectedItems}
                                    onSelectionChanged={this.selectionChanged}
                                    itemTitleRender={() => (
                                        <Toolbar className="accordian-toolbar">
                                        <Item location="before">
                                            <div className="title">
                                                <h6
                                                    style={{color: window._env_.Color2}}
                                                >
                                                   Replicate Sales Orders using the settings below.
                                                </h6>
                                            </div>
                                        </Item>
    
                                        <Item location="after">
                                            <Button  className="accordianButton" onClick={this.ReplicateButtonClicked} text="Start" type="default" />
                                        </Item>
                                        <Item location="after">
                                            <Button  className="accordianButton" onClick={this.previewButtonClicked} text="Preview" />
                                        </Item>
                                        <Item location="after">
                                            <Button  className="accordianButton" onClick={this.resetButtonClicked} text="Reset" />
                                        </Item>
                                        <Item location="after">
                                            <Button  className="accordianButton" onClick={this.printErrorsButtonClicked} text="Print Errors" />
                                        </Item>
                                    </Toolbar>
                                    )}
                                    itemRender={(itemProps) => (
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <fieldset className="h-100">
                                                        <legend className="h6">Replicate Settings</legend>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <SelectBox
                                                                    dataSource={this.arrProfileMethod}
                                                                    value={this.state.settings.profilemethod}
                                                                    valueExpr='id'
                                                                    displayExpr='text'
                                                                    className="light-ui-textbox"
                                                                    label="Profile Method"
                                                                    onValueChanged={(e) => this.ProfileMethodChanged(e)}
                                                                />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <SelectBox
                                                                    dataSource={this.state.settings.newWHArr}
                                                                    value={this.state.settings.newwarehouse}
                                                                    valueExpr='rowid'
                                                                    displayExpr='code'
                                                                    className="light-ui-textbox"
                                                                    label="New WH"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("newwarehouse", e.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 py-2">
                                                                <SelectBox
                                                                    dataSource={this.state.settings.profileArr}
                                                                    value={this.state.settings.profileid}
                                                                    valueExpr='id'
                                                                    displayExpr='name'
                                                                    className="light-ui-textbox"
                                                                    label="Profile"
                                                                    disabled={!this.state.settings.isProfileNeeded}
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("profileid", e.value)}
                                                                />
                                                            </div>
                                                            <div className="col-md-6 py-2">
                                                                <TextBox
                                                                    className="light-ui-textbox"
                                                                    label="PO #"
                                                                    maxLength={20}
                                                                    value={this.state.settings.ponumber}
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("ponumber", e.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 py-2">
                                                                <SelectBox
                                                                    dataSource={this.arrStage}
                                                                    value={this.state.settings.stage}
                                                                    displayExpr="name"
                                                                    valueExpr="value"
                                                                    name="stage"
                                                                    className="light-ui-textbox"
                                                                    label="Stage"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("stage", e.value)}
                                                                />
                                                            </div>
                                                            <div className="col-md-6 py-2">
                                                                <SelectBox
                                                                    dataSource={this.arrUpdatePrices}
                                                                    value={this.state.settings.updateprices}
                                                                    displayExpr="name"
                                                                    valueExpr="value"
                                                                    className="light-ui-textbox"
                                                                    label="Update Prices"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("updateprices", e.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 py-2">
                                                                <SelectBox
                                                                    dataSource={this.arrStatus}
                                                                    value={this.state.settings.status}
                                                                    displayExpr="name"
                                                                    valueExpr="value"
                                                                    name="status"
                                                                    className="light-ui-textbox"
                                                                    label="Status"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("status", e.value)}
                                                                />
                                                            </div>
                                                            <div className="col-md-6 py-2">
                                                                <SelectBox
                                                                    dataSource={this.arrClearDiscounts}
                                                                    value={this.state.settings.cleardiscounts}
                                                                    displayExpr="name"
                                                                    valueExpr="value"
                                                                    name=""
                                                                    className="light-ui-textbox"
                                                                    label="Clear Discounts"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("cleardiscounts", e.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                                <div className="col-md-3">
                                                    <fieldset className="h-100">
                                                        <legend className="h6">Order Date</legend>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <SelectBox
                                                                    dataSource={this.arrDateMethod}
                                                                    value={this.state.settings.orderdatemethod}
                                                                    displayExpr="name"
                                                                    valueExpr="value"
                                                                    className="light-ui-textbox"
                                                                    label="Method"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("orderdatemethod", e.value)}
                                                                />
                                                            </div>
                                                            <div className="col-md-12 py-2">
                                                                <NumberBox
                                                                    className="light-ui-textbox"
                                                                    label="# of Days"
                                                                    disabled={!this.state.settings.isOrderNoOfDaysEnabled}
                                                                    value={this.state.settings.ordernoofdays}
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("ordernoofdays", e.value)}
                                                                />
                                                            </div>
                                                            <div className="col-md-12 py-2">
                                                                <DateBox
                                                                    className="light-ui-textbox"
                                                                    label="Order Date"
                                                                    value={this.state.settings.orderdate}
                                                                    name="orderDate"
                                                                    type="datetime"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("orderdate", e.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                                <div className="col-md-3">
                                                    <fieldset className="h-100">
                                                        <legend className="h6">Ship Date</legend>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <SelectBox
                                                                    dataSource={this.arrDateMethod}
                                                                    value={this.state.settings.shipdatemethod}
                                                                    displayExpr="name"
                                                                    valueExpr="value"
                                                                    className="light-ui-textbox"
                                                                    label="Method"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("shipdatemethod", e.value)}
                                                                />
                                                            </div>
                                                            <div className="col-md-12 py-2">
                                                                <NumberBox
                                                                    className="light-ui-textbox"
                                                                    label="# of Days"
                                                                    value={this.state.settings.shipnoofdays}
                                                                    disabled={!this.state.settings.isShipNoOfDaysEnabled}
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("shipnoofdays", e.value)}
                                                                />
                                                            </div>
                                                            <div className="col-md-12 py-2">
                                                                <DateBox
                                                                    className="light-ui-textbox"
                                                                    label="Order Date"
                                                                    value={this.state.settings.shipdate}
                                                                    name="shipDate"
                                                                    type="datetime"
                                                                    onValueChanged={(e) => this.ReplicateSettingsValuesChanged("shipdate", e.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            </div>
                                    )}
                                    id="accordion-container" className="accordion-height"
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ minWidth: "900px" }}>
                        <Form
                            id="form"
                            labelMode="static"
                            labelLocation="left"
                            formData={this.state.formData}
                            items={this.state.formItems}
                            colCount={5}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className={this.state.opened ? 'toolbar-holder' : 'toolbar-holder collapse-drawer '}>
                        <Toolbar items={this.toolbarItems} />
                    </div>
                </div>
                <div className="row bg-white">
                    <div>
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            onHiding={(() => this.setState({ loadIndicatorVisible: false }))}
                            visible={this.state.loadIndicatorVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <Drawer
                            opened={this.state.opened}
                            openedStateMode={'shrink'}
                            position={'left'}
                            revealMode={'slide'}
                            render={() =>
                                <List
                                    ref={list}
                                    dataSource={this.state.report.whereInfoList}
                                    pageLoadMode="scrollBottom"
                                    style={{ backgroundColor: '#F6F7FB' }}
                                    displayExpr="displayLabel"
                                    searchEnabled={true}
                                    searchExpr="displayLabel"
                                    showSelectionControls={true}
                                    selectionMode="multiple"
                                    onSelectionChanged={this.dataFieldSelectionChanged}
                                    onItemRendered={this.dataFieldRender}
                                ></List>}
                            closeOnOutsideClick={false}
                            className={this.state.selectedItems.length>0? "ReportFilterPanelHeightAccordionOpen" : "GridHeightTabPanel-with-toolbar"}>
                            <div>
                                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                                    id="gridContainer"
                                    ref={dataGrid}
                                    showBorders={true}
                                    className={this.state.selectedItems.length>0?(this.state.formItems.length>0?"WMReportGridHeightWithAccordianDouble":"WMRTGridStyle"):"WMReportGridStyle-AccordianClosed"}
                                    rowAlternationEnabled={true}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    onEditorPreparing={this.editorPreparing}
                                    onCellClick={this.CellClik}
                                >
                                    <Editing
                                        mode="cell"
                                        newRowPosition="last"
                                        refreshMode="repaint"
                                        allowUpdating={true}
                                        useIcons={true}
                                    />
                                    <Column
                                        dataField="displayLabel"
                                        caption="Display Label"
                                        allowEditing={false}
                                    />
                                    <Column dataField="orderBy" caption="Order By">
                                        <Lookup
                                            dataSource={orderByDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="prefix" caption="Prefix">
                                        <Lookup
                                            dataSource={prefixDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="group" caption="Group">
                                        <Lookup
                                            dataSource={groupDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="operation" caption="Operation">
                                        <Lookup
                                            dataSource={operationDataSource}
                                            displayExpr="Text"
                                            valueExpr="ID"
                                        />
                                    </Column>
                                    <Column dataField="from" caption="From" />
                                    <Column dataField="to" caption="To" />
                                    <Column caption="" allowEditing={false} cellRender={this.searchPopupCellRender} />
                                </DataGrid>
                            </div>
                        </Drawer>
                    </div>
                </div>
                {this.state.isPreviewGridPopupVisible &&
                    <Popup
                        visible={this.state.isPreviewGridPopupVisible}
                        onHiding={this.handleClosePreviewPopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title={"Preview"}
                        container=".dx-viewport"
                        closeOnOutsideClick={true}
                    >
                        <ScrollView width="100%" height="100%">
                            <CommitTransactionsGridPreview dataSource={this.state.previewData} />
                        </ScrollView>
                    </Popup>
                }
                {this.state.isPrintPreviewPopupVisible &&
                    <Popup
                        visible={this.state.isPrintPreviewPopupVisible}
                        onHiding={this.handleClosePrintErrorsPopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title={"Print Errors"}
                        container=".dx-viewport"
                        closeOnOutsideClick={true}
                    >
                        <ScrollView width="100%" height="100%">
                            <CommitTransactionsPrintErrors dataSource={this.state.ABErros} reportname="ABR003" reportformat="Standard Abecas" />
                        </ScrollView>
                    </Popup>
                }
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ReplicateOMTransaction);
